import React from "react"
import { postConsent } from "../services/consent-service"

function AgreeButton({ id, rrn, opt, redirect }) {
  const [disable, setDisable] = React.useState(false)

  const submitConsent = (e) => {
    setDisable(true) // disable click after first click
    e.target.style.backgroundColor = "lightgray"
    postConsent(id, rrn, opt, redirect)
  }

  return (
    <button
      type="button"
      className="btn"
      disabled={disable}
      onClick={submitConsent}
    >
      Continue
    </button>
  )
}

export default AgreeButton
